module.exports = __webpack_public_path__ + "img/Dantam Hair 24.7e1fc4f2.jpg";